<template>
  <div class="cookies-page">
    <!-- Header con imagen y título sobrepuesto -->
    <div class="cookies-header">
      <img
        class="cookies-header-img"
        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRL7-p5TG9fgrAyNixqLkfTZbxtTOQ3DXfCyQ&s"
        alt="Header cookies"
      />
      <div class="cookies-title-card">
        <span class="cookies-title">{{ content.title }}</span>
      </div>
    </div>
    <!-- Cuerpo del texto -->
    <div class="cookies-body">
      <p>{{ content.intro }}</p>

      <p>
        <span class="cookies-section-title">{{ content.whatAreCookiesTitle }}</span><br>
        {{ content.whatAreCookies }}
      </p>

      <p class="cookies-section-title">{{ content.typesTitle }}</p>
      <ul>
        <li v-for="(type, i) in content.typesList" :key="i">{{ type }}</li>
      </ul>

      <p>
        <span class="cookies-section-title">{{ content.controlTitle }}</span><br>
        {{ content.controlText }}
      </p>

      <p>
        <span class="cookies-section-title">{{ content.changesTitle }}</span><br>
        {{ content.changesText }}
      </p>
    </div>

    <!-- Footer -->
    <SiteFooter :selectedLang="selectedLang" />
  </div>
</template>

<script>
import { useSEO } from '@/composables/useSEO';
import { cookiesPolicy } from '@/assets/data/data.ts';
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  name: "PoliticasDeCookies",
  components: {
    SiteFooter
  },
  props: {
    selectedLang: {
      type: String,
      default: "es"
    }
  },
  setup() {
    useSEO({
      title: 'Políticas de Cookies',
      description: 'Política de uso de cookies en el sitio web de Frenkel Engineering. Información sobre qué cookies usamos y cómo puedes gestionarlas.',
      path: '/politicas-cookies',
    });
  },
  computed: {
    content() {
      return cookiesPolicy[this.selectedLang] || cookiesPolicy.es;
    }
  }
};
</script>

<style scoped>
.cookies-page {
  width: 100%;
  min-height: 100vh;
  background: #f6fafb;
  font-family: 'IBM Plex Mono', monospace;
  padding-bottom: 30px;
}
.cookies-header {
  position: relative;
  width: 100%;
  background: #fff;
  min-height: 210px;
  border-bottom: 1.5px solid #ccc;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}
.cookies-header-img {
  width: 100%;
  min-height: 210px;
  max-height: 240px;
  object-fit: cover;
  border-bottom: 1.5px solid #ccc;
  background: #fff;
  display: block;
}
.cookies-title-card {
  position: absolute;
  left: 50%;
  bottom: 16px;
  transform: translateX(-50%);
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 4px 14px 0 rgba(60,60,60,0.18);
  padding: 0.6rem 2.2rem 0.5rem 2.2rem;
  min-width: 300px;
  border: 2px solid #222;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}
.cookies-title {
  font-family: 'Caveat-Bold', cursive;
  font-size: 2.5rem;
  font-weight: bold;
  text-align: justify;
  color: #111;
  letter-spacing: 0.01em;
}
.cookies-body {
  max-width: 900px;
  margin: 32px auto 0 auto;
  padding: 0 34px;
  color: #222;
  font-family: 'IBM Plex Mono', monospace;
  font-size: 1.04em;
  letter-spacing: 0.01em;
}
.cookies-section-title {
  font-weight: bold;
  font-size: 1em;
  letter-spacing: 0.01em;
}
ul {
  padding-left: 1.7em;
  margin-top: 0.3em;
  margin-bottom: 1.7em;
}
li {
  margin-bottom: 5px;
  font-size: 1em;
  list-style-type: disc;
}
.cookies-body p {
  margin: 0 0 18px 0;
  line-height: 1.43;
  white-space: pre-line;
}
@media (max-width: 650px) {
  .cookies-header-img {
    min-height: 120px;
    max-height: 130px;
  }
  .cookies-title-card {
    font-size: 1.1rem;
    padding: 0.3rem 0.7rem;
    min-width: 130px;
  }
  .cookies-title {
    font-size: 1.3rem;
  }
  .cookies-body {
    padding: 0 9px;
    font-size: 0.93em;
  }
}
</style>
